import { createAsyncThunk } from '@reduxjs/toolkit';

import getUserData from 'services/users/getUserData';

export const getUserDataAction = createAsyncThunk('users/getUserData', async (uid) => {
  const userData = await getUserData(uid);

  return { userData };
});
